
export const burjanfanni = {
  personal_video: {
    title: "Személyes videóüzenet rendelése",
    description: "Rendelj egy személyre szabott, vidám videóüzenetet magadnak vagy szeretteidnek",
    button: "Megrendelem",
    price: {
      standard: "3 990 Ft",
      premium: "5 990 Ft",
      exclusive: "9 990 Ft"
    }
  },
  video_message: {
    orderForm: {
      occasionSection: "Milyen alkalomra szeretnéd?",
      occasion: {
        birthday: "Születésnap",
        nameday: "Névnap",
        motivation: "Motiváció",
        congratulation: "Gratuláció",
        other: "Egyéb"
      },
      title: "Személyre szabott videóüzenet",
      subtitle: "Kérj tőlem egy személyes videóüzenetet",
      recipientInfo: "Kinek készüljön a videó?",
      forMyselfLabel: "Magamnak kérem a videót",
      recipientNameLabel: "Kinek készüljön a videó?",
      recipientNamePlaceholder: "Pl. Zsuzsi",
      senderNameLabel: "Ki kéri a videót?",
      senderNamePlaceholder: "Pl. Gábor",
      instructionsLabel: "További információk, kérések",
      instructionsPlaceholder: "Itt leírhatod, hogy pontosan mit szeretnél, hogy mondjak a videóban...",
      submit: "Megrendelés"
    }
  },
  bundle: {
    title: "Exkluzív csomagok",
    description: "Válogass kedvedre a személyre szabott csomagok közül",
    details: {
      includesTitle: "A csomag tartalma:",
      buyButton: "Megvásárolom",
      backButton: "Vissza a csomagokhoz",
      process: {
        title: "Hogyan működik?",
        steps: [
          {
            title: "Válassz egy csomagot",
            description: "Böngéssz az exkluzív csomagok között és válaszd ki a számodra legmegfelelőbbet."
          },
          {
            title: "Fizesd ki a rendelést",
            description: "Biztonságos fizetési rendszerünkön keresztül rendezd a vásárlást."
          },
          {
            title: "Hozzáférés a tartalomhoz",
            description: "A sikeres fizetés után azonnal hozzáférsz az összes tartalomhoz."
          },
          {
            title: "Személyes elemek ütemezése",
            description: "Egyeztetünk a videóüzenet vagy személyes találkozó részleteiről."
          }
        ]
      },
      faq: {
        title: "Gyakori kérdések",
        questions: [
          {
            question: "Meddig férhetek hozzá a tartalomhoz?",
            answer: "A megvásárolt digitális tartalmakhoz korlátlan ideig hozzáférsz a fiókodon keresztül."
          },
          {
            question: "Hogyan kapom meg a videóüzenetet?",
            answer: "A személyes videóüzenetet a fiókodba töltöm fel, erről értesítést fogsz kapni emailben."
          },
          {
            question: "Meddig érvényes a csomag?",
            answer: "A csomagok a vásárlástól számított 3 hónapig érvényesek, ez idő alatt fel kell használnod a személyes elemeket."
          },
          {
            question: "Lemondhatom a találkozót?",
            answer: "A lefoglalt időpont előtt 48 órával van lehetőség lemondásra vagy átütemezésre."
          }
        ]
      },
      reviews: {
        title: "Vásárlói vélemények",
        average: "Átlagos értékelés",
        reviews: [
          {
            name: "Kovács Anna",
            rating: 5,
            date: "2023. december 15.",
            comment: "Fantasztikus élmény volt! A csomag minden eleme tökéletes, a személyes találkozón nagyon kedves volt Fanni."
          },
          {
            name: "Nagy Péter",
            rating: 5,
            date: "2023. november 3.",
            comment: "A legjobb ajándék, amit valaha adtam! Mindenki imádta a videóüzenetet, amit a barátnőmnek készített Fanni."
          },
          {
            name: "Tóth Bence",
            rating: 4,
            date: "2023. október 22.",
            comment: "Nagyon elégedett vagyok a csomaggal, csak ajánlani tudom mindenkinek, megéri az árát!"
          }
        ]
      }
    }
  }
};
